<template>
  <v-container class="restaurant-list-container">
    <v-container class="grid">
      <restaurant-card
        :user-token="userToken"
        v-for="restaurant in restaurants"
        v-bind:key="restaurant.id"
        v-bind:restaurant="restaurant"
        v-bind:restaurants="restaurants"
      ></restaurant-card>
    </v-container>
    <v-pagination
      v-model="page"
      :length="Math.ceil(pagination.total / filter.limit)"
      @input="$emit('load-restaurant', page)"
      :value.sync="page"
      circle
    ></v-pagination>
  </v-container>

</template>

<script>
import RestaurantCard from "../Restaurants/RestaurantCard";
export default {
  name: "restaurant-list",
  components : {
    RestaurantCard,
  },

  props:["restaurants", "pagination", "filter", 'userToken'],
  data() {
    return {
      page: this.pagination.page,
      pageSize: this.pagination.total / this.filter.limit
    };
  },
}
</script>

<style scoped>
.restaurant-list-container{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.grid {
  display: grid;
  grid-template-columns: repeat(4, 25%);
  grid-gap: 15px;
}
@media screen and (max-width: 1024px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(3, 33%);
  }
}
@media screen and (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(2, 50%);
  }
}
@media screen and (max-width: 480px) {
  .grid {
    grid-template-columns: 100%;
  }
}
</style>
